import React, { useContext } from 'react';
import CATModel from '../../../models/CATModel';
import ModuleContext from '../../../CMFW/context/ModuleContext';
import CATPanel from './CATPanel';
import styled from 'styled-components';

export type IProps = {};

const CATAIReasoning: React.FC<IProps> = () => {
  const module = useContext(ModuleContext) as CATModel;
  const active = module.getActive();

  const renderReasoning = () => {
    if (active === null || !active.aiReasoning) {
      return null;
    }

    return <ReasoningText>{active.aiReasoning}</ReasoningText>;
  };

  return <CATPanel title={'AI Reasoning'}>{renderReasoning()}</CATPanel>;
};

export default CATAIReasoning;

const ReasoningText = styled.div`
  padding: 10px;
  font-size: 13px;
  color: #333;
  line-height: 1.5;
  white-space: pre-wrap;
`;
